import React from 'react';
import { JcCommonProps, JcUtils } from 'jcsdk';

interface JcCardGroupProps extends JcCommonProps {
    title: string;
    children: React.ReactNode;
}

export const JcCardGroup = (props: JcCardGroupProps): React.ReactElement => {
    const commonProps = JcUtils.commonProps(props, ["jc-card-group"])
    return <section {...commonProps}>
        <h2 className="jc-card-group-title"><span>{props.title}</span></h2>
        <div>
            {props.children}
        </div>
    </section>;
}